(function () {
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  $$('[data-autosubmit]').forEach(function (el) {
    el.addEventListener('change', function () {
      var f = el.form;
      if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else f.submit();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details[data-close-on-esc][open]').forEach(function (d) {
      d.open = false;
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });
  $$('[data-close-details]').forEach(function (b) {
    b.addEventListener('click', function () { var d = b.closest('details'); if (d) d.open = false; });
  });
  $$('.hdr__drawer').forEach(function (d) {
    d.addEventListener('click', function (e) { if (e.target === d) d.open = false; });
    d.addEventListener('toggle', function () { document.documentElement.style.overflow = d.open ? 'hidden' : ''; });
  });
  document.addEventListener('click', function (e) {
    $$('.hdr__dd[open], .hdr__search[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
  $$('.hdr__search').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      var i = d.querySelector('input[type=search]');
      if (i) setTimeout(function () { i.focus(); }, 30);
    });
  });

  var fd = document.querySelector('[data-facets-drawer]');
  if (fd && window.matchMedia('(min-width: 990px)').matches) fd.open = true;

  $$('[data-gallery]').forEach(function (g) {
    var t = g.querySelector('[data-gallery-track]'), c = g.querySelector('[data-gallery-count]');
    if (!t || !c) return;
    t.addEventListener('scroll', function () {
      c.textContent = Math.round(t.scrollLeft / Math.max(t.clientWidth, 1)) + 1;
    }, { passive: true });
  });

  var lb = document.querySelector('[data-lightbox]');
  if (lb && lb.showModal) {
    var img = lb.querySelector('[data-lb-img]');
    $$('[data-zoom]').forEach(function (b) {
      b.addEventListener('click', function () {
        img.src = b.getAttribute('data-zoom');
        img.alt = b.getAttribute('data-alt') || '';
        lb.showModal();
      });
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target === img || e.target.closest('[data-lb-close]')) lb.close();
    });
  }

  var main = document.querySelector('[data-main-atc]'), bar = document.querySelector('[data-sticky-atc]');
  if (main && bar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button, a', bar).forEach(function (x) { x.tabIndex = show ? 0 : -1; });
    }).observe(main);
  }

  $$('[data-countdown]').forEach(function (el) {
    var day = parseInt(el.getAttribute('data-day'), 10);
    var hour = parseInt(el.getAttribute('data-hour'), 10);
    var tz = el.getAttribute('data-tz') || 'America/Los_Angeles';
    function nowIn() {
      try { return new Date(new Date().toLocaleString('en-US', { timeZone: tz })); } catch (e) { return new Date(); }
    }
    function set(k, v) {
      var n = el.querySelector('[data-cd=' + k + ']');
      if (n) n.textContent = (v < 10 ? '0' : '') + v;
    }
    function tick() {
      var now = nowIn(), t = new Date(now.getTime());
      t.setHours(hour, 0, 0, 0);
      var add = (day - now.getDay() + 7) % 7;
      if (add === 0 && now >= t) add = 7;
      t.setDate(t.getDate() + add);
      var s = Math.max(0, Math.floor((t - now) / 1000));
      var d = Math.floor(s / 86400); s %= 86400;
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      set('d', d); set('h', h); set('m', m); set('s', s);
    }
    tick();
    setInterval(tick, 1000);
  });
})();